// Keep one request active; never keep old names indefinitely after a failed refresh.
export function startMailboxPolling({ url, onData, onError, onLoading, onExpire,
  fetchFn = fetch, refreshMs = 60000, retryMs = 15000, timeoutMs = 25000,
  staleMs = 120000 }) {
  let stopped = false;
  let nextTimer;
  let expiryTimer;
  let deadlineTimer;
  let controller;
  let cancelPending;

  async function poll() {
    controller = new AbortController();
    let succeeded = false;
    const interrupted = new Promise((_, reject) => {
      cancelPending = () => reject(new Error('Briefkastenanzeige konnte nicht geladen werden. Erneuter Versuch läuft automatisch.'));
      deadlineTimer = setTimeout(() => { controller.abort(); cancelPending(); }, timeoutMs);
    });
    try {
      const payload = await Promise.race([
        (async () => {
          const response = await fetchFn(url, { signal: controller.signal, cache: 'no-store' });
          const body = await response.json();
          if (!response.ok) {
            const error = new Error(body.error || 'Briefkastenanzeige konnte nicht geladen werden.');
            error.status = response.status;
            throw error;
          }
          if (!Array.isArray(body.items)) throw new Error('Ungültige Antwort der Briefkastenanzeige.');
          return body;
        })(), interrupted,
      ]);
      if (stopped) return;
      succeeded = true;
      clearTimeout(expiryTimer);
      onData(payload);
      onError('');
      expiryTimer = setTimeout(() => {
        if (!stopped) {
          onExpire();
          onError('Briefkastenanzeige wird erneut geladen.');
        }
      }, staleMs);
    } catch (error) {
      if (!stopped) {
        if (error.status === 401 || error.status === 403) {
          clearTimeout(expiryTimer);
          onExpire();
        }
        onError(error.message || 'Briefkastenanzeige konnte nicht geladen werden.');
      }
    } finally {
      clearTimeout(deadlineTimer);
      if (!stopped) {
        onLoading(false);
        nextTimer = setTimeout(poll, succeeded ? refreshMs : retryMs);
      }
    }
  }
  poll();
  return () => {
    stopped = true;
    clearTimeout(nextTimer);
    clearTimeout(expiryTimer);
    clearTimeout(deadlineTimer);
    controller.abort();
    cancelPending();
  };
}
